// extracted by mini-css-extract-plugin
module.exports = {"CategoryCellContainer":"CategoryCell_CategoryCellContainer__B-JZC","CategoryLabel":"CategoryCell_CategoryLabel__39mkZ","SubCategoryLabel":"CategoryCell_SubCategoryLabel__h4jEN"};